import { render, staticRenderFns } from "./TopicLinksTag.vue?vue&type=template&id=84acf452"
import script from "./TopicLinksTag.vue?vue&type=script&lang=js"
export * from "./TopicLinksTag.vue?vue&type=script&lang=js"
import style0 from "./TopicLinksTag.vue?vue&type=style&index=0&id=84acf452&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports